import Vue from 'vue'
import axios from 'axios'

let instance

/** Returns the current instance */
export const getInstance = () => instance

/** Creates an instance of the ApiClient. If one has already been created, it returns that instance */
export const useApiClient = (baseUrl) => {
  if (instance) return instance

  console.log(baseUrl)

  // The 'instance' is simply a Vue object
  instance = new Vue({
    methods: {
      organisationGetAll () {
        return this.get('Organisation/GetAll')
      },
      async get (url) {
        let token = await this.$auth.getTokenSilently()
        let response = await this.apiClient.get(url, { headers: { Authorization: 'Bearer ' + token } })
        return response.data
      }
    },
    /** Use this lifecycle method to instantiate the SDK client */
    async created () {
      // Create a new instance of the axios client
      this.apiClient = axios.create({ baseURL: baseUrl })
      console.log(baseUrl)
    }
  })

  return instance
}

// Create a simple Vue plugin to expose the wrapper object throughout the application
export const ApiClient = {
  install (Vue, baseUrl) {
    Vue.prototype.$apiClient = useApiClient(baseUrl)
  }
}



// WEBPACK FOOTER //
// ./src/helper/apiClient.js